import React, { useMemo } from 'react';
import OverviewMetricCards from './OverviewMetricCards';
import { useHullStabilityFilter } from '../../../contexts/HullStabilityFilterContext';

type AveragePowerShape = {
  crewAverage: number;
  powerRange: { min: number; max: number };
  consistency: number;
  peakPower: number;
  [key: string]: unknown;
} | null;

interface OverviewMetricCardsWithHullFilterProps {
  data: AveragePowerShape;
  loading: boolean;
  hasError: boolean;
}

const OverviewMetricCardsWithHullFilter: React.FC<OverviewMetricCardsWithHullFilterProps> = ({
  data,
  loading,
  hasError,
}) => {
  const { setStrokesOnly, activeMetrics, hasData } = useHullStabilityFilter();

  const displayData = useMemo(() => {
    if (!data || hasError) return null;
    if (!setStrokesOnly || !activeMetrics) return data;
    return {
      ...data,
      crewAverage: activeMetrics.crewAverage,
      powerRange: activeMetrics.powerRange,
      consistency: activeMetrics.consistency,
      peakPower: activeMetrics.peakPower,
    };
  }, [data, hasError, setStrokesOnly, activeMetrics]);

  return (
    <OverviewMetricCards
      data={displayData}
      loading={loading}
      filterNote={setStrokesOnly && hasData ? 'Set strokes only' : undefined}
    />
  );
};

export default OverviewMetricCardsWithHullFilter;
